import { gql } from "apollo-angular";

import { ERROR_RESULT_FRAGMENT } from "../../../common/graphql/fragments.graphql";

export const REGISTER = gql`
    mutation Register($input: RegisterCustomerInput!) {
        registerCustomerAccount(input: $input) {
            ... on Success {
                success
            }
            ...ErrorResult
        }
    }
    ${ERROR_RESULT_FRAGMENT}
`;

export const GET_AVAILABLE_COUNTRIES = gql`
    query GetAvailableCountries {
        availableCountries {
            id
            code
            name
        }
    }
`;

export const CHECK_USER_BY_EMAIL = gql`
    query CheckUserByEmail($email: String!) {
        userExists(email: $email)
    }
`;
